import React, { useEffect, useState, useMemo } from 'react'
import VideoJS from './player'
import videojs from 'video.js';
import { useLocation } from 'react-router-dom';
import 'video.js/dist/video-js.css';
import { useHistory } from 'react-router-dom';
import "videojs-markers"
import { useDispatch, useSelector } from 'react-redux';
// import { advertise_seen_count_change } from '../actions/MovieAction';
import * as HomeAction from '../actions/HomeActions';
import { bindActionCreators } from 'redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxHeight: "70vh",
  width: 400,
  bgcolor: 'rgb(25,25,25)',
  border: '2px solid rgb(255,255,255,0.5)',
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};

require("@silvermine/videojs-quality-selector")(videojs);

export default function VideoFile() {

  const playerRef = React.useRef(null);
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const user_id = JSON.parse(sessionStorage.getItem('user'))?.id
  const { VideoSeenCount } = bindActionCreators(HomeAction, dispatch)
  let index = 0

  useEffect(() => {
    (async () => {
      if (location?.state?.data?.video) {
        const resData = await VideoSeenCount({ video: location?.state?.data?.video, user: user_id })

      }

    })()
  }, [])


  const videoJsOptions = {
    autoplay: true,
    loop: false,
    controls: true,
    responsive: true,
    fluid: true,
    muted: false,
    textTrackSettings: false,
    // playbackRates: [0.5, 1, 1.5, 2],
    userActions: { hotkeys: true },
    controlBar: {
      qualitySelector: true,
      fullscreenToggle: true,
      volumePanel: { inline: true },
      pictureInPictureToggle: false,
      skipButtons: {
        forward: 10,
        backward: 10
      }

    },
    tracks: location?.state?.subtitle?.map((ele) => ({ src: ele?.subtitle_file, kind: 'subtitles', srclang: 'en', label: ele?.subtitle_language })),
    audio: location?.state?.audio?.map((ele) => ({
      id: ele?.id,
      kind: 'alternative',
      label: ele?.audio_language,
      language: ele?.audio_language,
      audio: ele?.audio_file
    })),

    sources: [
      {
        src: `${location?.state?.data?.audio ? location?.state?.data?.audio[index]?.audio_file : location?.state?.data?.Trailer}`,
        type: location?.state?.data?.audio?.length
          ? location.state.data.audio[index]?.audio_file?.split('.').pop()?.toLowerCase() === 'm3u8'
            ? "application/x-mpegURL"
            : "video/mp4"
          : location?.state?.data?.Trailer?.split('.').pop()?.toLowerCase() === 'm3u8'
            ? "application/x-mpegURL"
            : "video/mp4",
        label: "360p",
      }

    ]

  };
  

  const handlePlayerReady = (player) => {
    var currentTime = 0;
    playerRef.current = player;
    // player?.addChild("QualitySelector")
    //  player.addChild("PlaybackRateMenuButton")
    player.controlBar.addChild('MenuButton', {
      className: 'audio_subtitle_resolution_controls',
      clickHandler: function () {
        if (!player.paused()) {
          player.pause()
        }

      }

    })
    player?.addChild("QualitySelector")

    player.addChild("fullscreenToggle")
    player.controlBar.removeChild("QualitySelector")
    //  player.controlBar.removeChild("PlaybackRateMenuButton")
    player.controlBar.removeChild("fullscreenToggle")
    player.titleBar.removeClass('vjs-hidden')
    player.titleBar.addChild('button', {
      controlText: `${location?.state?.data?.movie_name}`,
      className: 'vjs-visible-text',
      position: 2,
    });
    player.markers({
      markerStyle: {
        'position': 'absolute',
        'height': '4px',
        'width': '4px',
        'top': "0",
        'background-color': 'yellow'
      },
    })


    player.addChild('button', {
      className: 'go-back',
      clickHandler: function (event) {
        history.goBack()
      }
    });

    player.on("userinactive", function () {
      document.getElementsByClassName("vjs-quality-selector")[0].style.display = "none"
      document.getElementsByClassName("vjs-fullscreen-control")[0].style.display = "none"
      document.getElementsByClassName(" go-back")[0].style.display = "none"



    })
    player.on("useractive", function () {
      document.getElementsByClassName("vjs-quality-selector")[0].style.display = "block"
      document.getElementsByClassName("vjs-fullscreen-control")[0].style.display = "block"
      document.getElementsByClassName(" go-back")[0].style.display = "block"
    })

    // You can handle player events here, for example:
    player.on('waiting', () => {
      videojs.log('player is waiting');
    });



    player.on('dispose', async () => {

    });


    player.on("seeking", () => {

      currentTime = player?.currentTime()
    })
    player.on("loadeddata", function () {

      setTimeout(() => {
        let QualitySelector = document.getElementsByClassName("vjs-quality-selector")[0]


        let AudioButton = document.getElementsByClassName("vjs-audio-button")[0]

        QualitySelector.classList.remove("vjs-hidden")
        QualitySelector.getElementsByClassName("vjs-menu")[0].classList.remove("vjs-hidden")
        QualitySelector.getElementsByClassName("vjs-menu")[0].classList.add("always-open")
        console.log("QualitySelector", QualitySelector)


        AudioButton.classList.remove("vjs-hidden")
        AudioButton.getElementsByClassName("vjs-menu")[0].classList.remove("vjs-hidden")
        AudioButton.getElementsByClassName("vjs-menu")[0].classList.add("always-open")
        AudioButton.getElementsByClassName("vjs-menu")[0].classList.add("margin-custom-audio")

        try {
          const li1 = document.createElement("li");
          li1.setAttribute("class", " vjs-menu-item vjs-alternative-menu-item custom-li");
          li1.appendChild(QualitySelector);

          document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("ul")[0].appendChild(li1)
        }
        catch (error) {
          console.log(error, "li1")
        }

        if (location?.state?.data?.audio?.length) {

          try {
            const li2 = document.createElement("li");
            li2.setAttribute("class", " vjs-menu-item vjs-alternative-menu-item custom-li li-second");
            li2.appendChild(AudioButton);
            document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("ul")[0].appendChild(li2)
            const audioLanguages = [
              { language: "English", code: "en" },
              { language: "Spanish", code: "es" },
              { language: "Hindi", code: "hi" },
              { language: "Gujarati", code: "gu" },
              { language: "Telugu", code: "te" },
              { language: "French", code: "fr" }
              // Add more languages as needed
            ];
  
            const audioMenu = document.getElementsByClassName("vjs-audio-button")[0].getElementsByClassName("vjs-menu")[0];
  
            while (audioMenu.firstChild) {
              audioMenu.removeChild(audioMenu.firstChild);
            }
  
            location?.state?.data?.audio?.forEach((language, indexData) => {
              const li2 = document.createElement("li");
              li2.setAttribute("class", "vjs-menu-item vjs-alternative-menu-item");
              li2.setAttribute("data-lang-code", language.audio_language); // Store the language code as a data attribute
              li2.textContent = language.audio_language; // Set the text content to the language name
              audioMenu.appendChild(li2);
              if (indexData == index) {
                li2.setAttribute("class", "vjs-menu-item vjs-selected");
  
              }
              li2.addEventListener("click", function () {
                console.log("indexData",location?.state?.data?.audio[indexData])
                index = indexData
                const currentTime = player.currentTime(); // Store the current play position
  
                li2.setAttribute("class", "vjs-menu-item vjs-selected");
  
                console.log("li2", li2)
                li2.classList.add("vjs-menu-item");
                li2.classList.add("vjs-selected");
  
                player.src({ type: 'application/x-mpegURL', src: language?.audio_file });
  
  
                player.one('loadedmetadata', function () {
                  player.currentTime(currentTime); // Seek to the stored position
                  player.play(); // Resume playback
                });
  
              });
            });
  
  
          }
          catch (error) {
            console.log(error, "li2")
          }



        } else {
          try {
            const li2 = document.createElement("li");
            li2.setAttribute("class", " vjs-menu-item vjs-alternative-menu-item custom-li li-second");
            li2.appendChild(AudioButton);
            document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("ul")[0].appendChild(li2)
          }
          catch (error) {
            console.log(error, "li2")
          }
        }






        let SubsCapsButton = document.getElementsByClassName("vjs-subs-caps-button")[0]
        SubsCapsButton.classList.remove("vjs-hidden")
        SubsCapsButton.getElementsByClassName("vjs-menu")[0].classList.remove("vjs-hidden")
        SubsCapsButton.getElementsByClassName("vjs-menu")[0].classList.add("always-open")
        try {
          const li3 = document.createElement("li");
          li3.setAttribute("class", " vjs-menu-item vjs-alternative-menu-item custom-li");
          li3.appendChild(SubsCapsButton);

          document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("ul")[0].appendChild(li3)
        }
        catch (error) {
          console.log(error, "li3")
        }

        var qualitySelectorItems = document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("ul");


        for (var i = 0; i < qualitySelectorItems.length; i++) {

          qualitySelectorItems[i].addEventListener("click", function (event) {
            event.stopPropagation()
            document.getElementsByClassName("audio_subtitle_resolution_controls")[0].getElementsByTagName("button")[0].click()

          });

        }
        var lis = document.getElementsByClassName("custom-li")
        for (var i = 0; i < lis.length; i++) {

          if (lis[i].children.length <= 0) {

            lis[i].remove()
          }
        }
        var lis = document.getElementsByClassName("li-second")
        for (var i = 0; i < lis.length; i++) {

          if (lis[i].children.length <= 0) {

            lis[i].remove()
          }
        }

      }, 1000)





    })


    player.on("qualityRequested", () => {
      if (player.play()) {
        player.pause()
      }

      console.log("videoJsOptions", videoJsOptions)
      const temp = document.getElementsByClassName("vjs-menu-item vjs-selected")[3].getElementsByClassName("vjs-menu-item-text")[0].innerText
      player.src(videoJsOptions.sources.find((ele) => ele?.label == temp))
      for (let i = 0; i < videoJsOptions.sources.length; i++) {
        videoJsOptions.sources[i].selected = (videoJsOptions.sources[i]?.label == temp)
      }
      currentTime = player?.currentTime()
      player.load();

    })


  };



  return (
    <>

      <div className='video-parent video trailer-file-qty-x'>
        <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
      </div>
      {/* <div onClick={() => history.goBack()} className='go-back' ><img src={left_arrow} width={"40px"}/></div> */}

    </>
  )
}


